import React, { CSSProperties, FunctionComponent, useMemo } from 'react';

import Button from '@gojob/ui-bits/Button';
import Icon from '@gojob/ui-bits/Icon';
import Filter from '@gojob/ui-bits/Icons/Filter';
import { Option } from '@gojob/ui-bits/PlacesAutocomplete/useRemoteOptions';

import useTranslation from 'src/translations/useTranslation';

export type FilterButtonProps = {
  radius?: number;
  city?: Option | null;
  onClick?: () => void;
  className?: string;
  style?: CSSProperties;
};

const FilterButton: FunctionComponent<FilterButtonProps> = (props) => {
  const { radius, city, onClick, className, style } = props;

  const t = useTranslation();

  const content = useMemo(() => {
    const [lng, lat] = city?.centre?.coordinates || [];
    if (!lng || !lat || !radius) {
      return t('filters');
    }
    return t('filters_{count}_km', { count: radius });
  }, [city, radius]);

  return (
    <Button outlined color="primary" onClick={onClick} className={className} style={style}>
      <Icon as={Filter} color="primary" margin={[0, 1, 0, -1]} size={5} />
      {content}
    </Button>
  );
};

export default FilterButton;
